export const getCouponList=async(dynamoDBClient)=>{
    try {
        const params1={
            TableName:"PromoGroup",
        }
        const data=await dynamoDBClient.scan(params1).promise()
        const table1=data.Items
        if(table1.length===0){
            return []
        }
        
        const result= []
        await Promise.all(table1.map(async(item)=>{
            const params2={
                TableName:"PromoCodes",
                IndexName:"PromoGroupId-index",
                KeyConditionExpression: 'PromoGroupId = :promoGroupId',
                FilterExpression:"IsUsed = :check",
                ExpressionAttributeValues: {
                    ':promoGroupId': item.PromoGroupId,
                    ":check":"true"
                },
                Select:"COUNT"
            }

            const data2=await dynamoDBClient.query(params2).promise()
            
            let active=data2?.Count
            let status=active>0?"Active":"-"
            
            if(data2?.LastEvaluatedKey){
                const params3={
                    TableName:"PromoCodes",
                    IndexName:"PromoGroupId-index",
                    KeyConditionExpression: 'PromoGroupId = :promoGroupId',
                    FilterExpression:"IsUsed = :check",
                    ExpressionAttributeValues: {
                        ':promoGroupId': item.PromoGroupId,
                        ":check":"true"
                    },
                    Select:"COUNT",
                    ExclusiveStartKey:data2.LastEvaluatedKey
                }
                const data3=await dynamoDBClient.query(params3).promise()
                
                
                active=active+data3.Count
                status=active>0?"Active":"-"
            }
            

            result.push({...item, activePromos:active,status})
            
        })
        )

        const sortedArray = result.sort((a, b) => {
            return new Date(b.DateCreated) - new Date(a.DateCreated);
        });
        
        return sortedArray


    } catch (error) {
        throw new Error
    }
    
}

export const getCouponCodesList=async(dynamoDBClient,id,exclusiveStartKey=null)=>{
    
    try {
        const params={
            TableName:"PromoCodes",
            IndexName:"PromoGroupId-index",
            KeyConditionExpression: 'PromoGroupId = :promoGroupId',
            ExpressionAttributeValues: {
                ':promoGroupId': id
            },
            Limit:1000,
            ProjectionExpression:"Code,Email,StartDate,ExpirationTime,PromoStatus",
            ExclusiveStartKey:exclusiveStartKey
        }
        

       

        const data=await dynamoDBClient.query(params).promise()
        
        
        return data
    } catch (error) {
        throw new Error
    }
}

export const getCouponDownloadList=async(dynamoDBClient,id,exclusiveStartKey=null)=>{
    const key=exclusiveStartKey?.Code===""?null :exclusiveStartKey
    
    try {
        const params={
            TableName:"PromoCodes",
            FilterExpression: 'PromoGroupId = :promoGroupId',
            ExpressionAttributeValues: {
                ':promoGroupId': id
            },
            Limit:4000,
            ProjectionExpression:"Code",
            ExclusiveStartKey:key
            
        }
        
        const data=await dynamoDBClient.scan(params).promise()
        
        return data
    } catch (error) {
        throw new Error
    }
}

export const getSubscriptionPlanList=async(dynamoDBClient)=>{
    const params = {
        TableName: 'Subscriptions',
        FilterExpression: 'PlanId = :id',
        ExpressionAttributeValues: {
            ':id': "1",
        },
        ProjectionExpression:"SubscriptionId,NoOfBeacons"
    };
    try {
        const data=await dynamoDBClient.scan(params).promise()
        const sortedData = data.Items.sort((a, b) => {
            return parseInt(a.NoOfBeacons) - parseInt(b.NoOfBeacons);
        });
        return sortedData
    } catch (error) {
        console.log("getsubscriptionplan error:",error)
        throw new Error(error)
    }
}